import type { ActionField } from "@wms/domain";
import type { Dayjs } from "dayjs";

/** CW31-B17: the words of a required text of only spaces in the dialog of an action. */
export const WHITESPACE_MESSAGE = "Заполните поле: одних пробелов недостаточно";

/** A field the dialog edits as free text (a reason, a comment, a number of a paper) — not a number, a switch, a list. */
export function isTextField(field: Pick<ActionField, "type">): boolean {
  return !field.type || field.type === "string";
}

/** CW31-B17: a required text is refused when it is empty or only spaces; other types keep the plain «required». */
export function actionFieldRules(field: Pick<ActionField, "type" | "required">) {
  if (!field.required || field.type === "boolean") return undefined;
  if (!isTextField(field)) return [{ required: true, message: "Обязательное поле" }];
  return [
    { required: true, message: "Обязательное поле" },
    {
      validator: (_: unknown, value: unknown) =>
        typeof value === "string" && value !== "" && value.trim() === "" ? Promise.reject(new Error(WHITESPACE_MESSAGE)) : Promise.resolve(),
    },
  ];
}

/**
 * The body of the action request: a date travels as «2026-10-25»; CW31-B17 — a text is sent trimmed, and an optional
 * text of only spaces is not sent at all (as if left empty). Numbers, switches and references go as they are.
 */
export function actionBody(fields: ActionField[], values: Record<string, unknown>): Record<string, unknown> {
  const body: Record<string, unknown> = { ...values };
  for (const f of fields) {
    const value = body[f.name];
    if (f.type === "date" && value) body[f.name] = (value as Dayjs).format("YYYY-MM-DD");
    if (isTextField(f) && typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed === "" && !f.required) delete body[f.name];
      else body[f.name] = trimmed;
    }
  }
  return body;
}
